import { render, staticRenderFns } from "./breadCrumb.vue?vue&type=template&id=f6137d20&scoped=true&"
import script from "./breadCrumb.vue?vue&type=script&lang=js&"
export * from "./breadCrumb.vue?vue&type=script&lang=js&"
import style0 from "./breadCrumb.vue?vue&type=style&index=0&id=f6137d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6137d20",
  null
  
)

export default component.exports